<template>
  <div class="container-fluid" id="app_top_menu">
    <div id="menu_top_part" class="row">
      <div class="col-xs-3" style="display: flex;flex-direction: row;align-items: center;">

        <div class="dropdown" id="left_menu_dropdown">
          <button type="button" class="btn dropdown-toggle" id="menu_more_tabs_btn" data-toggle="dropdown">
          </button>
          <ul class="dropdown-menu" role="menu" aria-labelledby="menu_more_tabs_btn" style="margin-top: 15px;">
            <li role="presentation" v-for="(item, index) in tabList">
              <div style="width: 90vw;">
                <a :href="item.src"
                   :class="['menu_tab_title', currentIndex==index ? 'active' : '']"
                >{{item.title}}</a>
                <div class="menu_sub_ul" v-if="item.subList != undefined && item.subList.length > 0">
                  <div v-for="(subItem, subIndex) in item.subList">
                    <a :href="item.src + '/' + subItem.id"
					href="javascript:void(0)"
					@click="subItemClicked(item.src, subItem.id)"
                       :class="['menu_sub_tab_title', subItem.id==tabId ? 'active' : '']"
                    >{{subItem.title}}</a>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <a id="menu_logo" href="/" style="margin-left: 3vw;">
          <img src="../assets/shl_logo_small.png">
        </a>
      </div>

      <div class="col-xs-9" id="menu_top_part_right">

        <div class="dropdown " style="margin-right: 2vw;">
          <button type="button" class="btn dropdown-toggle" id="menu_search_btn" data-toggle="dropdown">
          </button>
          <ul class="dropdown-menu"  role="menu" aria-labelledby="menu_search_btn">
            <li role="presentation">
              <input type="text" id="menu_search_input" v-model="keyword" placeholder="输入关键字搜索" @keyup.enter="searchClose"  />
            </li>
          </ul>
        </div>

<!--        <a id="menu_wechat_login" href="#">-->
<!--          <img src="../assets/shl_menu_wechat.png" >-->
<!--        </a>-->

        <div style="position: relative;">
          <a id="menu_wechat_login"
             href="javascript:void(null);"
             class="btn dropdown-toggle"
             data-toggle="dropdown"
             style="text-align: center;display: flex;align-items: center;justify-content: center;">
            <img src="../assets/shl_menu_wechat.png" style="text-align: center;" >
          </a>
          <ul class="dropdown-menu" style="left: -55px;" role="menu" aria-labelledby="menu_wechat_login">
            <li role="presentation" style="padding: 0;left: 0;">
              <div style="width: 150px;text-align: center;margin-left: 3px;">
                <img src="../assets/shl_wechat_qrcode.jpg" style="width: 100%;height: auto;">
                <span >关注官方微信公众号</span>
              </div>
            </li>
          </ul>
        </div>


        <a href="mailto:shba@shslqxh.com" id="menu_mail_login">
          <img src="../assets/shl_menu_mail.png">
        </a>

        <a href="/personal/center" v-if="nickName != null" class="small-nickname menu_margin_right_0_5">{{nickName}}</a>
        <a v-if="nickName != null" class="menu_margin_right_0_5" ><img src="../assets/shl_vertical_line.png" style="height: 1.3rem;width: auto;margin-top: -0.4rem;"></a>
        <a v-if="nickName != null" href="javascript:void (null);" @click="loginOut" class="menu_margin_right_3_2" style="min-width: 3rem">退出</a>

        <a v-if="nickName == null" href="/login" class="menu_margin_right_3_2">登录</a>
<!--        <a v-if="nickName == null" href="/login" class="menu_margin_right_0_5">登录</a>-->
<!--        <a v-if="nickName == null" class="menu_margin_right_0_5"><img src="../assets/shl_vertical_line.png" style="height: 1.1rem;width: auto;margin-top: -0.2rem;"></a>-->
<!--        <a v-if="nickName == null" href="/register" class="menu_margin_right_3_2" style="text-align: right;">注册</a>-->
      </div>
    </div>

<!--    <div id="menu_bottom_part" class="row">-->
<!--      -->
<!--    </div>-->
  </div>
</template>

<script>
import GlobalInstance from '../js/shba'
export default {
  name: "AppSmallTopMenu",
  data() {
    return {
      keyword: '',
      tempUserName: null,
    }
  },
  computed: {
    eventManager() {
      return this.$store.state.eventManager;
    },
    tabId() {
      return GlobalInstance.methods.currentSubTabId(this.$route);
    },
    params() {
      return this.$route.params;
    },
    path() {
      return this.$route.path;
    },
    currentIndex() {
      let index = GlobalInstance.methods.currentMenuIndex(this.$route);
      return index >= 0 ? index : 0;
    },
    tabList() {
      return this.$store.state.tabList
    },
    nickName() {
      if (this.tempUserName == null) {
        let user = this.$store.state.dataStore.getUser();
        if (user != null) {
          this.tempUserName = user.nickName;
        }
      }
      return this.tempUserName;
    },
  },
  mounted() {
    let _this = this;
    this.checkToken(this.$store, function (data) {
      let code = data.code;
      if (code != 0) {
        _this.tempUserName = null;
      }
    })

    this.eventManager.register('app-big-top-menu', this.eventManager.notificationNameObject.UserUpdate, function () {
      let user = _this.$store.state.dataStore.getUser();
      _this.tempUserName =  user == null ? null : user.nickName;

    });
  },
  destroyed() {
    this.eventManager.unregister('app-big-top-menu', this.eventManager.notificationNameObject.UserUpdate);
  },
  methods: {
	  subItemClicked(src, id) {
	  	let path = src + '/' + id;
	  	if (src == '/training' && id == '0504') {
        let user = this.$store.state.dataStore.getUser();
        if (user != null && user.isTeam == 1) { // 团体用户
          this.$router.push(src);
        } else {
          if (user == null) {
          	this.$router.push("/login");
          } else {
          	this.$router.push({
          		name: 'personalPage'
          	});
          }
        }
	  	} else {
	  		this.$router.push(path);
	  	}
	  },

    menuTabClicked(tabId) {
      this.$store.commit('tabIndexChanged', tabId);
    },
    searchClose() {
      if (this.keyword != '') {
        GlobalInstance.search.searchClose(this.$router, this.keyword);
      }
    },
    loginOut() {
      let _this = this;
      this.$store.state.http.ajax.userSignOut(function (data) {

        _this.tempUserName = null;
      }, function (data) {
        _this.tempUserName = null;
      });
    },
  }
}
</script>

<style scoped>
  #app_top_menu {
    background: #e71a34 url("../assets/shl_top_menu_bg.png") no-repeat center top;
    background-size: auto 100%;
    max-height: 202px;
    height: 14.8858vw;
  }

  #menu_top_part {
    height: 100%;
    padding: 0;
  }


  #menu_top_part > div {
    height: inherit;
    max-height: inherit;
  }
  #menu_top_part_right {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }

  #menu_logo > img {
    height: 7.51vw;
    width: auto;
  }

  #menu_top_part_right a{
    color: white;
    font-size: 1.5rem;
    font-weight: bold;
    text-decoration: none;
  }

  .menu_margin_right_3_2 {
    margin-right: 2.8vw;
  }
  .menu_margin_right_0_5 {
    margin-right: 1vw;
  }


  #menu_mail_login, #menu_wechat_login {
    background-color: rgba(255, 255, 255, 0.3);
    width: 2.4rem;
    height: 2.4rem;
    border-radius: 1.2rem;
    flex-direction: row;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }

  #menu_mail_login {
    margin-right: 3.3vw;
  }
  #menu_mail_login img {
    /*width: 1.9160vw;*/
    height: 1.1rem;
    width: auto;
  }

  #menu_wechat_login {
    margin-right: 1vw;
  }

  #menu_wechat_login img {
    height: 1.1rem;
    width: auto;
  }

  #menu_search_input {
    outline: none;
    text-indent: 2rem;
    height: 30px;
    width: 150px;
    border: none;
    font-size: 1rem;
    color: #333;
    letter-spacing: 1px;
  }
  #menu_search_input::-webkit-input-placeholder {
    color: #999;
  }

  #left_menu_dropdown a {
    color: black;
    text-decoration: none;
    text-align: center;
    padding-top: 5px;
    padding-bottom: 5px;
    /*min-width: 100px;*/
  }
  #left_menu_dropdown a:hover, #left_menu_dropdown a.active {
    color: white;
  }

  #left_menu_dropdown a.active {
    pointer-events: none;
  }

  #menu_search_btn {
    background-image: url("../assets/shl_menu_search.png");
    width: 1.5rem;
    height: 1.5rem;
    background-color: transparent;
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
  }

  #menu_more_tabs_btn {
    background-image: url("../assets/shl_menu_more_tabs.png");
    width: 4vw;
    height: 4vw;
    background-color: transparent;
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
  }
  #left_menu_dropdown ul {
    background-color: #c61a34;
  }

  .menu_sub_ul {
    display: flex;
    width: 100%;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    background-color: rgba(0, 0, 0, 0.15);
    padding-top: 10px;
    padding-bottom: 10px;
  }

  #menu_bottom_part a {
    color: white;
  }

  .menu_tab_title {
    font-size: 1.5rem;
    padding: 8px 15px;
    display: inline-block;
  }
  .menu_sub_tab_title {
    font-size: 1rem;
    padding: 0px 15px;
    display: inline-block;
  }
  #menu_bottom_part a.active {
    color: black;
    pointer-events: none;
  }

  .small-nickname {
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
</style>



// WEBPACK FOOTER //
// src/components/AppSmallTopMenu.vue